import { Decimal } from "@syla/shared/decimal";
import { financialYearToDateRange } from "@syla/shared/helpers/financialYear";

export const formatAsCurrency = (value: Decimal) =>
  value.format({
    currencyCode: "AUD",
    separateThousands: true,
    fixedPointDigits: 0,
  }).text;

export const formatFinancialYear = (financialYear) => {
  const [startDate, endDate] = financialYearToDateRange(financialYear);

  return `FY ${startDate.getFullYear()}-${endDate.getFullYear()}`;
};
